/* global locales */
import angular from 'angular';
import moment from 'moment';
import 'angular-bootstrap';
import locales from '../../locale';
import './meetingsServices';
import '../users/appUsersServices'

const meetingsControllers = angular.module('applicationModule.meetingsControllers', [
    'ngAnimate',
    'applicationModule.appUsersServices',
    'applicationModule.meetingsServices',
    'ui.bootstrap'
]);
// Meetings List Controller
meetingsControllers.controller('MeetingsListController', ['$scope', '$rootScope', '$stateParams', 'NgTableParams', 'Meeting', 'growl', 'AppsoupAPI', 'Permissions', '$filter', '$locale', function ($scope, $rootScope, $stateParams, NgTableParams, Meeting, growl, AppsoupAPI, Permissions, $filter, $locale) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('meetings');
    $scope.application_id = $stateParams.application_id;
    $scope.isLoading = false;
    $scope.lang = $filter('translate')('LANG');
    if (locales[$scope.lang] && locales[$scope.lang].DATETIME_FORMATS) {
        angular.copy(locales[$scope.lang].DATETIME_FORMATS, $locale.DATETIME_FORMATS);
    }

    $scope.tableParams = new NgTableParams(AppsoupAPI.getDateTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return Meeting.getList($scope.application_id, params._params).then(function (response) {
                params.total(response.meetings.total);
                params.count(response.meetings.per_page);
                params.page(response.meetings.current_page);

                $scope.statuses = response.statuses;

                return response.meetings.data;
            }).finally(function () {
                $scope.isLoading = false;
            });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.remove = function ($event) {
        $event.stopImmediatePropagation();
    };

    $scope.removeMeeting = function (id, index) {
        Meeting.remove(id, $scope.application_id)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    growl.success('MODULES.MEETINGS.SUCCESS.DELETE_MEETING');
                    $scope.tableParams.data.splice(index, 1);
                } else {
                    growl.error('MODULES.MEETINGS.ERROR.DELETE');
                }
            });
    };

    // DatePickers
    $scope.report = {
        start_date: new Date(),
        end_date: new Date()
    };

    $scope.popup_start = {
        opened: false
    };

    $scope.popup_end = {
        opened: false
    };

    $scope.format = 'dd-MM-yyyy';

    $scope.dateOptions = {
        dateDisabled: false,
        formatYear: 'yy',
        startingDay: 1
    };

    $scope.startDate = function () {
        $scope.popup_start.opened = true;
    };

    $scope.endDate = function () {
        $scope.popup_end.opened = true;
    };

    $scope.generateCSV = function (report) {
        var end_date = moment(report.end_date).format('YYYY-MM-DD');
        var start_date = moment(report.start_date).format('YYYY-MM-DD');
        $scope.isLoadingReport = true;
        Meeting.downloadReport($scope.application_id, end_date, start_date)
            .then(function (result) {
                let data = result.data;

                if (angular.isDefined(data.error)) {
                    growl.error(data.error);
                } else if (data) {
                    angular.openInNewTab(data);
                } else {
                    growl.error(data.error);
                }
            }).finally(function () {
            $scope.isLoadingReport = false;
        });
    };

}]);
// Meeting Page Controller
meetingsControllers.controller('MeetingPageController', ['$scope', '$rootScope', '$stateParams', '$filter', '$state', 'Meeting', 'MeetingAPI', 'growl', 'Permissions', 'AppUsers', '$locale', function ($scope, $rootScope, $stateParams, $filter, $state, Meeting, MeetingAPI, growl, Permissions, AppUsers, $locale) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('meetings');
    $scope.app_id = $stateParams.application_id;
    $scope.editMode = false;
    $scope.beacons = [];
    $scope.users = [];
    $scope.meeting = {
        date_time: {
            date: Date.now(),
            time: new Date()
        }
    };
    $scope.isLoading = false;
    $scope.lang = $filter('translate')('LANG');
    if (locales[$scope.lang] && locales[$scope.lang].DATETIME_FORMATS) {
        angular.copy(locales[$scope.lang].DATETIME_FORMATS, $locale.DATETIME_FORMATS);
    }

    $scope.checkDate = function () {
        $scope.meeting.date_time.date = $filter('date')($scope.meeting.date_time.date, 'yyyy-MM-dd');
    };
    $scope.autocomplete = function (text) {
        text = encodeURIComponent(text);
        text = text.toLowerCase().trim();
        AppUsers.search($scope.app_id, text).then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.users = data.users;
            } else {
                growl.error('MODULES.APPLICATIONS.MODULES.MEETINGS.GROWL.ERROR.' + data.error);
            }
        });
    };
    Meeting.getBeacons().then(function (response) {
        if (response.data.success) {
            $scope.beacons = response.data.beacons;
        }
    });

    if (angular.isDefined($stateParams.meetingId)) {
        $scope.editMode = true;
        $scope.isLoading = true;
        $rootScope.doingResolve = true;
        var meetingId = $stateParams.meetingId;
        Meeting.get(meetingId, $scope.app_id).then(function (result) {
            let data = result.data;

            if (data.success) {
                var meeting = data.meeting;
                var date = new Date();
                var time = '' + meeting.date_time.time;
                var hour = time.split(':')[0];
                var minutes = time.split(':')[1];
                date.setHours(hour, minutes);
                meeting.date_time.time = date;

                $scope.meeting = meeting;
            } else {
                growl.error('MODULES.MEETINGS.' + data.error);
            }
        }).catch(function () {
            $state.go('appsoup.application.meetings', {application_id: $scope.app_id}, growl.error('ERROR.EMPTY_DATA'));
        }).finally(function () {
            $rootScope.doingResolve = false;
            $scope.isLoading = false;
        });
    }

    $scope.ok = function () {
        $scope.$broadcast('show-errors-check-validity');

        if ($scope.meetingForm.$valid) {
            $scope.meeting.app_id = $scope.app_id;
            $scope.isLoading = true;
            var meeting = angular.copy($scope.meeting);
            meeting.date_time.date = $filter('date')(meeting.date_time.date, 'yyyy-MM-dd');
            meeting.date_time.time = $filter('date')(meeting.date_time.time, 'HH:mm');
            Meeting.save(meeting, $scope.editMode).then(function (result) {
                let data = result.data;

                if (data.success) {
                    growl.success('MODULES.MEETINGS.SUCCESS.MEETING_' + ($scope.editMode ? 'EDITED' : 'CREATED'));
                    $state.go('appsoup.application.meetings', {application_id: $scope.app_id});
                } else {
                    if (typeof data.error === 'object') {
                        if (angular.isDefined(data.error.meeting)) {
                            growl.error('MODULES.MEETINGS.' + data.error.meeting[0]);
                        } else {
                            $scope.formErrors = data.error;
                        }
                    } else {
                        growl.error('MODULES.MEETINGS.ERROR.MEETING_CREATED');
                    }
                }
            }).finally(function () {
                $scope.isLoading = false;
            });
        }
    };
    $scope.cancel = function () {
        $state.go('appsoup.application.meetings', {application_id: $scope.app_id});
    };

    $scope.inputErrors = {
        'mobile_user_id': [{type: '$invalid', msg: 'FORM.ERRORS.REQUIRED'}],
        'date_time': [{type: '$invalid', msg: 'FORM.ERRORS.REQUIRED'}],
        'duration': [
            {error: 'required', msg: 'FORM.ERRORS.REQUIRED'},
            {error: 'pattern', msg: 'FORM.ERRORS.FORMAT'},
            {error: 'min', msg: 'FORM.ERRORS.FORMAT'},
            {error: 'max', msg: 'FORM.ERRORS.FORMAT'}
        ]
    };
}]);

export default meetingsControllers;
